import React from 'react';
import { connect } from 'react-redux';
import { getQuestionMessageIdsByModel } from 'Store/reducers';

import styles from './GameQuestions.scss';
import GameQuestion from 'Components/GameQuestion';
import ConnectedFormattedMessage from 'Containers/ConnectedFormattedMessage';

class GameQuestions extends React.PureComponent {
  render() {
    const { slug, questionMessageIds, theme } = this.props;
    return (
      <div className={`GameQuestions GameQuestions--${theme}`}>
        <header className="GameQuestions__header">
          <div className="GameQuestions__headline">
            <ConnectedFormattedMessage id="game_questions.title" />
          </div>
        </header>
        <ul className="GameQuestions__items">
          {questionMessageIds.map((id, i) => {
            return (
              <GameQuestion
                text={<ConnectedFormattedMessage id={id} />}
                key={`${slug}-question-${i}`}
                theme={theme}
                appSlug={slug}
              />
            );
          })}
        </ul>
      </div>
    );
  }
}

const mapStateToProps = (state, { slug }) => {
  return {
    questionMessageIds: getQuestionMessageIdsByModel(state, slug),
  };
};

export default connect(mapStateToProps)(GameQuestions);
